import {
  commonValidationSchemas,
  createValidationSchema,
} from 'infrastructure/functions';

export const appendixCValidationSchema = () => {
  return createValidationSchema({
    whichPerson: commonValidationSchemas
      .string({
        nullable: true,
        required: true,
      })
      .oneOf(['Patient', 'Spouse', 'Caregiver', 'Other']),
    otherPerson: commonValidationSchemas.string({
      when: {
        fields: ['whichPerson'],
        is: (whichPerson) => whichPerson === 'Other',
        then: { required: true, min: 1 },
      },
    }),
    callType: commonValidationSchemas
      .string({
        nullable: true,
        required: true,
      })
      .oneOf(['inbound', 'outbound']),
    callTypeExtra: commonValidationSchemas.array(
      commonValidationSchemas.string(),
      { nullable: true },
    ),
    reasonForCall: commonValidationSchemas.array(
      commonValidationSchemas.string(),
      {
        min: 1,
        required: true,
        nullable: false,
      },
    ),
  });
};

export const monthlyInteractionCallValidationSchema = () => {
  return createValidationSchema({
    additionalEducationalMaterialsSent: commonValidationSchemas.string({
      required: true,
    }),

    deliveryMethod: commonValidationSchemas
      .string()
      .when('additionalEducationalMaterialsSent', {
        is: 'yes',
        then: commonValidationSchemas.string({ required: true }),
        otherwise: commonValidationSchemas.string().notRequired(),
      }),
  });
};

export const noReadingsValidationSchema = () => {
  return createValidationSchema({
    usedDevice: commonValidationSchemas.array(
      commonValidationSchemas.string(),
      {
        min: 1,
        required: true,
        nullable: false,
      },
    ),
    lastUseDuration: commonValidationSchemas
      .string({
        nullable: true,
        required: true,
      })
      .oneOf(['14', '30', '45']),
  });
};

export const wrupUpValidationSchema = () => {
  return createValidationSchema({
    goalToUseDeviceOther: commonValidationSchemas.string({
      when: {
        fields: ['goalToUseDevice'],
        is: (goalToUseDevice) => goalToUseDevice === 'Other',
        then: { required: true, min: 1 },
      },
    }),
  });
};
